import apiApp from "./index";
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const token = localStorage.getItem("UserjwtToken");
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
    const subTenantId = decodedToken?.subTenantId;
    return subTenantId ? `&subTenantId=${subTenantId}` : "";
  } else if (switched && switchedSubtenant) {
    return `&subTenantId=${switchedSubtenant?.id}`;
  }
  return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers with conditional tenant-login
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const TenantApi = {
  // Create Role Api

  tenantsList: (page, limit) => {
    const token = localStorage.getItem("UserjwtToken");
    return new Promise((resolve, reject) => {
      apiApp
        .get(`/tenants?page=${page}&size=${limit}&sort=desc`, {
          headers: getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  auditTrail: (page, limit, tenantId) => {
    return new Promise((resolve, reject) => {
      apiApp
        .get(`/audit/tenant/${tenantId}?page=${page}&size=${limit}&sort=desc`, { ///api/v1/audit/tenant/{id}
          headers: getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // Single tenants Api
  Singletenants: (tenantsId) => {
    return new Promise((resolve, reject) => {
      apiApp
        .get(`/tenant/${decodedToken?.tenantId}`, {
          headers: getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  TenantDetails: (tenantId) => {
    return new Promise((resolve, reject) => {
      apiApp
        .get(`/tenant/${tenantId}`, {
          headers: getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // Edit tenants Api
  Edittenants: (tenantsID, data) => {

    // if (decodedToken?.subTenantIds) {
    //   const subTenantIds = decodedToken?.subTenantIds?.split(',');
    //   const jsonData = JSON.parse(data);
    //   jsonData.subTenantDTO = { id: subTenantIds[0] };
    //   data = JSON.stringify(jsonData);
    // }
    // const headers = {
    //   Authorization: `Bearer ${token}`,
    //   "x-Authorization": `${decodedToken?.tenantApiKey}`,
    // };
    return new Promise((resolve, reject) => {
      apiApp
        .put(`/tenant/${tenantsID}`, data, {
          headers: getHeaders(),
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // create Tenant API
  CreateTenant: (data) => {

    return new Promise((resolve, reject) => {
      apiApp
        .post(`/tenant`, data, { headers: getHeaders() })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data || error.message));
    });
  },

  // delete Tenant API
  DeleteTenant: (tenantID) => {

    return new Promise((resolve, reject) => {
      apiApp
        .delete(`/tenant/${tenantID}`, { headers: getHeaders() })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data || error.message));
    });
  },

  // add whitel;osted ips
  AddWhiteListedIPs: (data) => {

    return new Promise((resolve, reject) => {
      apiApp
        .patch(`/tenant/${decodedToken?.tenantId}/whitelisted-ips`, data, { headers: getHeaders() })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response?.data || error.message));
    });
  },

};

export default TenantApi;
